"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "@/components/common/link/link";
import css from "./card.module.scss";
import Image from "@/components/common/image/image";
import ArrowIcon from "../arrow-icon/arrow-icon";
import { addQueryParams } from "@/utilities/url";
import CurvedUnderline from "@/components/common/curved-underline/curved-underline";
import type { PortableText as PortableTextType } from "@/sanity/sanity.types";
import CardDescription from "./card-description";
import { ImageLoading } from "@/utilities/imageLoading";
export enum CardStyle {
  Primary = "primary",
  Secondary = "secondary",
  Tertiary = "tertiary",
}
interface ICard {
  title: string;
  className?: string;
  description?: string | PortableTextType;
  fetchPriority?: "high" | "low";
  hoverEffect?: boolean;
  iconHasBackground?: boolean;
  imgHeight?: number;
  imgLoading?: ImageLoading;
  imgSizes?: string;
  imgSrcSet?: string;
  imgUrl?: string;
  imgWidth?: number;
  linkLabel?: string;
  linkUrl?: string;
  style?: CardStyle;
  ctaId?: string;
  ctaValue?: string;
  relValue?: string;
  label?: string;
}
const Card = props => {
  const $ = _c(24);
  const {
    title,
    className: t0,
    description,
    fetchPriority,
    hoverEffect: t1,
    iconHasBackground: t2,
    imgHeight,
    imgLoading: t3,
    imgUrl,
    imgSizes,
    imgSrcSet,
    imgWidth,
    linkLabel,
    linkUrl,
    style: t4,
    ctaId,
    ctaValue,
    relValue,
    label
  } = props;
  const className = t0 === undefined ? "" : t0;
  const hoverEffect = t1 === undefined ? false : t1;
  const iconHasBackground = t2 === undefined ? false : t2;
  const imgLoading = t3 === undefined ? ImageLoading.LAZY : t3;
  const style = t4 === undefined ? CardStyle.Primary : t4;
  const hoverClasses = hoverEffect ? "hover:!bg-[#00698F] hover:text-white" : "";
  const hoverImageClasses = hoverEffect ? iconHasBackground ? "transition group-hover:[filter:invert(100%)whitescale(100%)brightness(120%)]" : "transition group-hover:brightness-0 group-hover:invert" : "";
  const hoverLinkClasses = hoverEffect ? "group-hover:text-white" : "";
  const hoverArrowClasses = hoverEffect ? "group-hover:brightness-0 group-hover:invert" : "";
  const cardBaseClasses = `
    ${css.card} ${css[style]}
    ${hoverClasses}
    relative
  `;
  const linkBaseClasses = `
    ${css.cardLink}
    text-[#00698F] ${hoverLinkClasses}
  `;
  const noLinkCardClasses = `
    ${css.card} ${css[style]} ${css.noLink}
    ${hoverClasses}
  `;
  let t5;
  if ($[0] !== cardBaseClasses || $[1] !== className || $[2] !== ctaId || $[3] !== ctaValue || $[4] !== description || $[5] !== fetchPriority || $[6] !== hoverArrowClasses || $[7] !== hoverImageClasses || $[8] !== hoverLinkClasses || $[9] !== imgHeight || $[10] !== imgLoading || $[11] !== imgSizes || $[12] !== imgSrcSet || $[13] !== imgUrl || $[14] !== imgWidth || $[15] !== label || $[16] !== linkBaseClasses || $[17] !== linkLabel || $[18] !== linkUrl || $[19] !== noLinkCardClasses || $[20] !== relValue || $[21] !== style || $[22] !== title) {
    t5 = linkUrl ? <Link className={`${className} ${cardBaseClasses} group`} href={linkUrl} data-cta-id={ctaId ?? ""} data-cta-value={ctaValue ?? ""} rel={relValue}>{imgUrl && <div className={`${css.cardImageWrapper} ${style === CardStyle.Tertiary ? "relative w-full overflow-hidden rounded-lg pb-[32px]" : ""}`}><Image className={`${css.cardImage} ${hoverImageClasses} ${style === CardStyle.Tertiary ? "aspect-[400/250] h-full w-full object-cover" : ""} `} src={imgUrl} alt={title} width={imgWidth} height={imgHeight} srcSet={imgSrcSet ? imgSrcSet : `${addQueryParams(imgUrl, {
          w: 560
        })} 560w, ${addQueryParams(imgUrl, {
          w: 390
        })} 390w`} sizes={imgSizes ? imgSizes : "(width <= 640px) 560px, 390px"} loading={imgLoading} fetchPriority={fetchPriority} /></div>}<h3>{title}</h3><CardDescription description={description} />{linkLabel && <div className={`${linkBaseClasses} relative inline-block ${style === CardStyle.Tertiary ? "font-workSans text-base font-semibold leading-5 tracking-[-0.08px] text-[#373B37]" : ""}`}><span className="relative z-10 flex items-center">{linkLabel}<ArrowIcon className={`ml-2 inline-block align-middle ${hoverArrowClasses}`} /></span><CurvedUnderline hoverLinkClasses={hoverLinkClasses} /></div>}</Link> : <div className="flex h-full flex-col"><div className={`${className} ${noLinkCardClasses}`}>{imgUrl && <div className={`${css.cardImageWrapper} `}><Image className={`${css.cardImage} ${hoverImageClasses}`} src={imgUrl} alt={title} width={imgWidth} height={imgHeight} srcSet={imgSrcSet} sizes={imgSizes} loading={imgLoading} /></div>}{label && <span className="text-center text-[13px] font-bold uppercase leading-[21px] tracking-[1px]">{label}</span>}<h3 className={`${label ? "font-['Lora'] text-[42px] font-black leading-[36px] tracking-[-1px]" : ""}`}>{title}</h3><div className="flex-grow"><CardDescription description={description} className="!text-[19px] font-normal leading-[29px]" /></div></div></div>;
    $[0] = cardBaseClasses;
    $[1] = className;
    $[2] = ctaId;
    $[3] = ctaValue;
    $[4] = description;
    $[5] = fetchPriority;
    $[6] = hoverArrowClasses;
    $[7] = hoverImageClasses;
    $[8] = hoverLinkClasses;
    $[9] = imgHeight;
    $[10] = imgLoading;
    $[11] = imgSizes;
    $[12] = imgSrcSet;
    $[13] = imgUrl;
    $[14] = imgWidth;
    $[15] = label;
    $[16] = linkBaseClasses;
    $[17] = linkLabel;
    $[18] = linkUrl;
    $[19] = noLinkCardClasses;
    $[20] = relValue;
    $[21] = style;
    $[22] = title;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  return t5;
};
export default Card;